import { render, staticRenderFns } from "./TaskEdit.vue?vue&type=template&id=1a551a2b&scoped=true"
import script from "./TaskEdit.vue?vue&type=script&lang=js"
export * from "./TaskEdit.vue?vue&type=script&lang=js"
import style0 from "./TaskEdit.vue?vue&type=style&index=0&id=1a551a2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a551a2b",
  null
  
)

export default component.exports